<template>
	<div>
		<div class="sec_top" style="position: relative;">
			<div style="position: absolute;top:0;width:100%; height: 2.1rem;z-index: 0;">
				<img style="width: 100%; height: 2.1rem;" src="@/assets/img/fruit-transfer/xtBG.png"/>
			</div>
			<!-- 标题 -->
			<div class="sec_top_title">
				<div class="sec_top_titles">
					<div class="sec_top_title_l"></div>
					<div class="sec_top_title_r"  v-if="!loginFlag">
						<img src="@/assets/img/fruit-transfer/icon13.png">
						<a href="http://192.168.15.45/main/#/home" class="login">登录</a>
						<!-- <a href="http://192.168.15.37/main/#/register" class="register">注册</a> -->
					</div>
					<div class="sec_top_title_r" style="color:#ffffff;" v-if="loginFlag">用户：{{userName}}</div>
				</div>
			</div>
			<div class="sec_top_navBar">
				<img src="@/assets/img/fruit-transfer/xtWZ.png" class="sec_logo">
			</div>
		</div>
		<!-- 导航  -->
		<div class="sjk_nav">
		  <ul>
			  <li v-for="(item,i) in nav" :key="i" ref="navLi"   @mouseenter="enter(i)"  @mouseleave="out(i,item.code)" :class="index===item.code ? 'navHover': '' ">
				  <img :src="item.src"/>
				  <a :href="item.href">{{item.name}}</a>
			  </li>
		  </ul>
		</div>
	</div>
</template>

<script>
	import setRemPc from '@/api/setrem'
	import queryConditionService from "@/api/platform-declare/fruit-transfer"
	export default {
		props:{
			index:{
				type:Number,
				default:1
			}
		},
    //props: ['index'],
    data() {
      return {
		  loginFlag:false,
		  userName:'',
		  hflag:false,
		  nav:[
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN1.png'),href: process.env.VUE_APP_NAV_BASE_URL + 'ch00108/',  name:'首页'},
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN2.png'),href: process.env.VUE_APP_NAV_BASE_URL + 'ch00140/',  name:'工作快讯'},
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN3.png'),href: process.env.VUE_APP_NAV_BASE_URL + 'ch00110/',  name:'通知公告'},
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN4.png'),href: process.env.VUE_APP_NAV_BASE_URL + 'ch00108/#cxMAP',  name:'创新地图'},
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN5.png'),href:'#/platform/fruit-transfer/list',  name:'成果转化',code:1},
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN6.png'),href: process.env.VUE_APP_NAV_BASE_URL + 'ch00116/',  name:'数据填报'},
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN7.png'),href:'#/platform/letter/list',  name:'互动交流',code:2},
			  {flag:false, src:require('@/assets/img/fruit-transfer/navN8.png'),href: process.env.VUE_APP_NAV_BASE_URL + 'ch00112/', name:'政策法规'},
		  ]
	  }
    },
    created() {
      // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
      setRemPc();
      window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法
	  
	  queryConditionService
	      .isLogin()
	      .then(res => {
			  //console.log('是否登录',res);
			if(res.status == 0){
				this.loginFlag = true
				this.userName = res.data.nickName;
			}
			this.$emit('login',this.loginFlag)
	      })
	      .catch(error => {
	        console.log('error',error);
	      })
    },
    methods: {
		enter(i){
			this.$refs.navLi[i].className = 'navHover'
		},
		out(i,code){
			this.$refs.navLi[i].className = ''
			if(code==this.index){
				this.$refs.navLi[i].className = 'navHover'
			}
		},
	}
  }
</script>

<style>
	ul,li {
		list-style: none;
		
	}
	.sjk_nav {
	    width: 100%;
	    height: 0.9rem;
	    /* background: #1064B4; */
	    background: #177BB1;
		
	}
	.sjk_nav ul {
		width: 15.5rem;
		height: 0.9rem;
		margin: 0 auto;
		display: -webkit-box;
		display: -moz-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
	}
	.sjk_nav ul .navHover {
		background-color: #FF4E4E;
	}
	.sjk_nav ul li {
	    flex: 1;
	    height: 0.9rem;
	    line-height: .9rem;
	    text-align: center;
	    transition: all .5s ease;
	}
	.sjk_nav ul li img{
		margin-top: -0.0777rem;
		margin-right: 0.05rem;
		width: 0.35rem;
		height: 0.35rem;
	}
	.sjk_nav ul li a {
	    font-size: .25rem;
	    font-family: PingFangSC-Regular, PingFang SC;
	    font-weight: 400;
	    color: #FFFFFF;
	}
	.sec_top {
		width: 100%;
		height: 2.1rem;
		/* background: url('~@/assets/img/fruit-transfer/xtBG.png') no-repeat 50% 0%; */
		background-size: cover;	
	}
	.sec_top_title {
		width: 100%;
		height: 0.38rem;
		background-color: rgba(11,60,96,.8);
		position: absolute;
		top:0;
		z-index: 999;
	}
	.sec_top .sec_top_titles {
       width: 15rem; 
       height: 0.35rem;
       margin: 0 auto;
    }
	.sec_top .sec_top_title_l {
		width: auto;
		float: left;
		font-size: .18rem;
		line-height: .35rem;
		color: #fff;
		letter-spacing: .012rem;
	}
	.sec_top_title_r {
		width: 4rem;
		float: right;
		line-height: .35rem;
		display: flex;
		justify-content: right;
	}
	.sec_top_title_r img {
		width: 0.23rem;
		height: 0.23rem;
		margin-top: 0.06rem;
		margin-right:0.09rem;
		/* position: absolute;
		left: 0;
		top: 0.07rem; */
	}
	.sec_top_title_r a {
		font-size: .19rem;
		color: #fff;
		/* border-right: 0.01rem solid #fff; */
	}
	.login {
		padding-right: 0.08rem;
	}
	.register {
		/* padding-left: 0.08rem; */
		border-right: 0;
	}
	.sec_top_navBar {
		width: 15.5rem;
		height: 1.26rem;
		line-height: 1.55rem;
		margin: 0 auto;
		position: relative;
		top:0.35rem;
		text-align: center;
	}
	.sec_logo {
		width: 9rem;
		height: 0.8rem;
		border: 0;
		vertical-align: middle;
	}
	.navList {
		position: absolute;
		right: 0;
		top: 0;
		height: 1.3rem;
		line-height: 2.4rem;
	}
	.navItem {
		width: auto;
		float: left;
		position: relative;
		height: 0.75rem;
		margin-left: 0.2rem;
	}
	.navItem a {
		color: #fff;
		font-size: .27rem;
		font-weight: 500;
	}
	a {
		text-decoration: none;
	}
	img {
	    border: 0;
	    vertical-align: middle;
	}
	.homeActive {
		width: 0.5rem;
		height: 0.035rem;
		background-color: #FFFFFF;
		border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		-moz-border-radius: .08rem .08rem .08rem .08rem;
		-webkit-border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		position: absolute;
		left: 0;
		bottom: -0.7rem;
		opacity: 0;
		-webkit-opacity: 0;
		-moz-opacity: 0;
		-khtml-opacity: 0;
		transition: .5s all ease;
	}
	.homeActive1 {
		width: 0.5rem;
		height: 0.035rem;
		background-color: #FFFFFF;
		border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		-moz-border-radius: .08rem .08rem .08rem .08rem;
		-webkit-border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		position: absolute;
		left: 0;
		bottom: -0.7rem;
		opacity: 1;
		-webkit-opacity: 1;
		-moz-opacity: 1;
		-khtml-opacity: 1;
		transition: .5s all ease;
	}
	.navActive {
		width: 1.1rem;
		height: 0.035rem;
		background-color: #FFFFFF;
		border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		-moz-border-radius: .08rem .08rem .08rem .08rem;
		-webkit-border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		position: absolute;
		left: -0.02rem;
		bottom: -0.7rem;
		opacity: 0;
		-webkit-opacity: 0;
		-moz-opacity: 0;
		-khtml-opacity: 0;
		transition: .5s all ease;
	}
	.navActive1 {
		width: 1.1rem;
		height: 0.035rem;
		background-color: #FFFFFF;
		border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		-moz-border-radius: .08rem .08rem .08rem .08rem;
		-webkit-border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
		position: absolute;
		left: -0.02rem;
		bottom: -0.7rem;
		opacity: 1;
		-webkit-opacity: 1;
		-moz-opacity: 1;
		-khtml-opacity: 1;
		transition: .5s all ease;
	}
</style>